/* u-facets — behaviour for snippets/tcg-facets.liquid.
 * Desktop: one dropdown open at a time (outside click / Esc close), checkboxes apply on change, price on its button/Enter.
 * Phones: the toggle opens a bottom sheet; choices apply with "Show results" (no reload per tap).
 * Every navigation locks the bar (is-loading) so a second click cannot mix filters while the page loads.
 */
(function () {
  if (customElements.get('u-facets')) return;
  const mobile = window.matchMedia('(max-width: 749px)');

  customElements.define('u-facets', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = '1';
      this.form = this.querySelector('.u-facets__form');
      this.toggle = this.querySelector('.u-facets__toggle');
      this.backdrop = this.querySelector('.u-facets__backdrop');
      this.dropdowns = Array.from(this.querySelectorAll('.u-facets__dd'));

      if (this.form) {
        this.form.addEventListener('change', (e) => {
          if (e.target.type === 'checkbox' && !mobile.matches) this.submit();
        });
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
      }

      // Sort select (tcg-sort uses an inline onchange submit): lock the bar too.
      const sort = this.querySelector('.u-sort');
      if (sort) sort.addEventListener('submit', () => this.lock());
      const sortSelect = sort && sort.querySelector('select');
      if (sortSelect) sortSelect.addEventListener('change', () => this.lock());

      // Chips and "clear all" are links: lock on click as well.
      this.querySelectorAll('a.u-facets__chip, a.u-facets__clear').forEach((a) => a.addEventListener('click', () => this.lock()));

      this.dropdowns.forEach((dd) => {
        dd.addEventListener('toggle', () => {
          if (!dd.open || mobile.matches) return;
          this.dropdowns.forEach((o) => { if (o !== dd) o.open = false; });
          // Keep the popover inside the viewport.
          dd.classList.remove('is-flip');
          const pop = dd.querySelector('.u-facets__pop');
          if (pop && pop.getBoundingClientRect().right > window.innerWidth - 8) dd.classList.add('is-flip');
        });
      });

      if (this.toggle) this.toggle.addEventListener('click', () => this.setSheet(!this.classList.contains('is-open')));
      const close = this.querySelector('.u-facets__close');
      if (close) close.addEventListener('click', () => this.setSheet(false));
      if (this.backdrop) this.backdrop.addEventListener('click', () => this.setSheet(false));

      this.onDocClick = (e) => {
        if (mobile.matches || this.contains(e.target)) return;
        this.dropdowns.forEach((dd) => { dd.open = false; });
      };
      this.onKey = (e) => {
        if (e.key !== 'Escape') return;
        if (this.classList.contains('is-open')) { this.setSheet(false); return; }
        const open = this.dropdowns.find((dd) => dd.open);
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      };
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);
      // On phones every group starts collapsed; on desktop none open after a resize either.
      mobile.addEventListener('change', () => { this.setSheet(false); this.dropdowns.forEach((dd) => { dd.open = false; }); });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
    }

    setSheet(open) {
      if (!this.toggle) return;
      this.classList.toggle('is-open', open);
      this.toggle.setAttribute('aria-expanded', String(open));
      if (this.backdrop) this.backdrop.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        const first = this.querySelector('.u-facets__close');
        if (first) first.focus();
      } else if (this.contains(document.activeElement)) {
        this.toggle.focus();
      }
    }

    lock() {
      this.classList.add('is-loading');
      this.setAttribute('aria-busy', 'true');
    }

    submit() {
      if (this.classList.contains('is-loading')) return;
      // Drop empty price inputs so they don't create empty filter params.
      this.form.querySelectorAll('input[type="number"]').forEach((i) => { i.disabled = i.value === ''; });
      this.setSheet(false);
      this.lock();
      this.form.submit();
    }
  });

  // Back/forward cache: a restored page must not stay locked.
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('u-facets.is-loading').forEach((el) => { el.classList.remove('is-loading'); el.removeAttribute('aria-busy'); });
  });
})();
